<div class="container">
  <div class="content">
    <div class="title-row">
      <span class="ktitle-tiny">Course Attachments</span>
    </div>
<app-upload-file
  #uploader
  [fileTypeInS3]="'COURSE_DOCUMENT'"
  [courseItemId]="courseItemId"
  (uploadComplete)="onChildUploadComplete()">
  <div overrideFooter>PDF, XLS, DOC, DOCX, JPG, PNG, WebP (max 10 MB each)</div>
</app-upload-file>

  </div>
</div>